import styled from 'styled-components'

import { Section } from 'components/Section'

export const Content = styled(Section)`
	max-width: 1600px;
	display: flex;
	flex-direction: column;
	row-gap: 32px;
`
